import React from "react";
import { colorLightGray } from "../../utils/palette";
import { Table } from "react-bootstrap";
import { LinkSpan } from "../../shared/components/form/FormElements";
// import {
//   CustomLoader,
//   FilterButton,
// } from "../../shared/components/TableElements";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { textAlign } from "../../utils/directions";

const SampleTable = ({
  data,
  //onViewAll,
  onContactSupport,
  //viewAllLoading,
  //onSaveReport,
}) => {
  const { t } = useTranslation("common");
  return (
    <div className={`card shadow-sm`}>
      <div className="card-body p-0">
        <div className="px-3 py-2 border-bottom d-flex justify-content-between align-items-center">
          {/* <div>{data?.length > 50 && <p>Showing the first 50 results:</p>}</div> */}
          <div>
            <SampleText>{t("sample_table_records_msg")}</SampleText>
          </div>
        </div>

        <div className="px-3 pt-2 pb-1 d-flex justify-content-between align-items-center">
          <div>
            {data?.length >= 20 && (
              <span
                style={{
                  background: "#DCFCE7",
                  color: "#166534",
                  //border: `1px solid ${colorStatusActive}`,
                  borderRadius: "25px",
                  width: "min-content",
                  whiteSpace: "nowrap",
                  padding: "0.25rem 0.5rem",
                  fontSize: "12px",
                  fontWeight: 500,
                }}
              >
                {t("showing_first_20_records")}
              </span>
            )}
          </div>
          {/* <div className="d-flex align-items-center gap-2">
            <FilterButton
              type="button"
              onClick={onSaveReport}
              disabled={!data?.length}
            >
              {t("save_report")}
            </FilterButton>
            <FilterButton
              type="button"
              onClick={onViewAll}
              disabled={viewAllLoading || !data?.length}
            >
              {viewAllLoading ? <CustomLoader /> : t("view_all")}
            </FilterButton>
          </div> */}
        </div>

        <div
          className="table-responsive px-3 pt-1 pb-2"
          style={{
            maxWidth: "calc(100vw - 500px)",
            whiteSpace: "nowrap",
            //padding: "12px",
            //maxHeight: "calc(100vh - 400px)",
          }}
        >
          <div
            style={{
              border: `1px solid ${colorLightGray}`,
              borderRadius: "5px",
              overflow: "auto", // this is critical
            }}
          >
            {data?.length ? (
              <Table
                size="md"
                className="mb-0"
                // style={{
                //   border: `1px solid ${colorLightGray}`,
                //   borderRadius: "5px",
                // }}
              >
                <thead
                  style={{ background: `#F9FAFB` }}
                  //className="table-light"
                >
                  <tr>
                    {Object.keys(data[0] || {}).map((col, i) => (
                      <th key={i}>{col}</th>
                    ))}
                  </tr>
                </thead>

                {/* <div style={{ height: "calc(100vh- 500px)", overflow: "auto" }}> */}
                <tbody>
                  {data.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      {Object.values(row).map((val, colIndex) => (
                        <td
                          key={colIndex}
                          style={{
                            maxWidth: "300px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                          title={val}
                        >
                          {val}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
                {/* </div> */}
              </Table>
            ) : (
              <NoRecordsText className="p-2">{t("no_records")}</NoRecordsText>
            )}
          </div>
        </div>

        <SupportSection className="d-flex align-items-center p-3 border-top gap-1">
          <span role="img" aria-label="light bulb">
            💡
          </span>
          <span>{t("not_what_you_expected")}</span>
          <LinkSpan onClick={onContactSupport}>
            {t("contact_support_for_custom_report")}
          </LinkSpan>
        </SupportSection>
      </div>
    </div>
  );
};

const SampleText = styled.p`
  text-align: ${textAlign};
`;

const NoRecordsText = styled.p`
  text-align: ${textAlign};
`;

const SupportSection = styled.div`
  text-align: ${textAlign};
`;

export default SampleTable;
